import React from 'react'
import _ from 'lodash'
import { utils, coreConstants, CodeListItem } from '@adc/ui-morpheus'
import { getSellerCodes } from '../providers/seller'
import { DEBOUNCE_WAIT } from '../constants/statics'

const { parseJSONData } = utils.json
const { MODES } = coreConstants.optionLists

export const VENUE_MODE_OPTIONS = [
  { key: MODES.ALL, value: MODES.ALL, text: 'All' },
  { key: MODES.INCLUDE, value: MODES.INCLUDE, text: 'Only' },
]

export const deserializeModeSelectDropdown = payloadString => {
  const parsed = parseJSONData(payloadString)
  const mode = _.get(parsed, 'mode', VENUE_MODE_OPTIONS.ALL)
  return mode === 'INCLUDE' ? _.get(parsed, 'value') : []
}

export const onSellerChange = (e, data, thisRef, sellerCodesSelected) => {
  thisRef.setState({
    [sellerCodesSelected]: data,
  })
}

export const onSellerSearchChange = _.debounce(
  async (e, data, thisRef, loading, sellerCodes) => {
    const { searchQuery } = data
    const searchVal = _.trim(searchQuery)
    if (searchVal.length > 2) {
      thisRef.setState({ [loading]: true })
      await setCodes(searchVal, thisRef, sellerCodes)
      thisRef.setState({ [loading]: false })
    } else {
      thisRef.setState({ [sellerCodes]: [] })
    }
  },
  DEBOUNCE_WAIT
)

const setCodes = async (searchVal, thisRef, sellerCodes) => {
  const result = await getSellerCodes(null, searchVal)
  const codesList = []

  if (result.content && result.content.length) {
    result.content.forEach(code => {
      codesList.push({
        value: code.seller_plan_code,
        text: code.seller_plan_code,
        content: (
          <CodeListItem
            item={{
              value: code.seller_plan_code,
              data: code.seller_plan_name,
            }}
          />
        ),
      })
    })
  }
  /**
   * NOTE: we are not going to sort here as we will be expecting API to sort for us.
   */
  thisRef.setState({
    [sellerCodes]: codesList,
  })
}
